
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire247b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire247b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("fGjqO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("JSq6p").then(()=>parcelRequire("50i7i"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


var $f1f9b7c3604aa354$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aT88m","index.ab10e13d.js","JSq6p","webfontloader.f903600d.js"]'));

// Message to the platform

class $22f5f922ddc3e706$export$2dffd0b5373a4389 {
    constructor(){
        this.game = undefined;
        window.addEventListener("message", (ev)=>{
            this.receive(ev.data);
        });
        window.pew = this;
    }
    // Events from website
    receive(data) {
        if (data.eventName) console.log("RECEIVING EVENT: " + data.eventName);
        if (!this.game) {
            console.error("Error: Game not set");
            return;
        }
        switch(data.eventName){
            // Game is fully visible
            case "play":
                this.game.play();
                break;
        }
    }
    // Called first time
    init(game, config) {
        this.game = game;
        let fonts = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = "" + v;
            if (key.toLowerCase().includes("font") && !key.toLowerCase().includes("color") && !key.toLowerCase().includes("size") && !fonts.includes(value) && !$22f5f922ddc3e706$var$excludedFonts.includes(value)) fonts.push(value);
        }
        if (fonts.length > 0) (parcelRequire("fGjqO")).then((webfont)=>{
            webfont.load({
                google: {
                    families: fonts
                },
                active: ()=>{
                    this.ready();
                }
            });
        });
        else this.ready();
    }
    /**
   * Send play event when game actualy starts
   */ gamestarted() {
        this.sendEvent({
            eventName: "start"
        });
    }
    /**
   * Send gameover event from game with endscore
   */ gameover(score, uitslag, custom) {
        this.sendEvent({
            eventName: "gameover",
            data: {
                score: score,
                uitslag: uitslag,
                custom: custom
            }
        });
    }
    /**
   * Send ready event so the game becomes clickable
   */ ready() {
        this.sendEvent({
            eventName: "ready"
        });
    }
    // Play sound in website
    playSound(sound) {
        if (sound) this.sendEvent({
            eventName: "sound",
            data: this.game.config.path + "/" + sound
        });
    }
    // Not used right now
    // Was used for loading sounds in website instead of in game
    preloadSounds(config) {
        let files = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = config.path + "/" + v;
            if (!files.includes(value) && key.includes("Sound")) files.push(value);
        }
        this.sendEvent({
            eventName: "preload-sounds",
            data: files
        });
    }
    /**
   * Send message to the game platform
   * @param event
   */ sendEvent(event) {
        console.log("SENDING EVENT: " + event.eventName);
        window?.parent?.postMessage(event, "*");
    }
    // Send score to website UI
    sendScore(score) {
        // Put score in an object like this for Score-event animation
        this.sendEvent({
            eventName: "score",
            data: {
                score: score
            }
        });
    // Send score as a number for no Score-event animation
    // this.sendEvent({eventName: "score", data: score})
    }
    // Send progress to website UI
    // Can be sent as number (0-100) or string (5/20) (used by Progress Text UI element)
    sendProgress(progress) {
        this.sendEvent({
            eventName: "progress",
            data: progress
        });
    }
    // Send time left to website UI (percentage 0-100)
    sendTimeleft(time) {
        this.sendEvent({
            eventName: "timeleft",
            data: time
        });
    }
    // Send lives to website UI (any number)
    sendLives(lives) {
        this.sendEvent({
            eventName: "lives",
            data: lives
        });
    }
}
// Web font loader should skip these
const $22f5f922ddc3e706$var$excludedFonts = [
    "Arial",
    "Helvetica",
    "Comic Sans MS",
    "Courier New",
    "Courier",
    "Georgia",
    "Lucida Sans Unicode",
    "Lucida Grande",
    "Geneva",
    "Times New Roman",
    "Trebuchet",
    "Verdana"
];


class $ac5fb69ba5837957$export$646feb54fbadbe06 {
    constructor(){
        this.x = 0;
        this.y = 0;
        this.angle = 0;
        this.speed = 1000;
        this.dropspeed = 900;
        this.tiletype = 0;
        this.visible = false;
    }
}
class $ac5fb69ba5837957$export$7913c052e22f8bf3 {
    constructor(){
        this.x = 0;
        this.y = 0;
        this.tiletype = 0;
    }
}
class $ac5fb69ba5837957$export$2616165974278734 {
    get bubble() {
        return this._bubble;
    }
    set bubble(value) {
        this._bubble = value;
    }
    constructor(){
        this.x = 0;
        this.y = 0;
        this.angle = 0;
        this.tiletype = 0;
        this.bubble = new $ac5fb69ba5837957$export$646feb54fbadbe06();
        this.nextbubble = new $ac5fb69ba5837957$export$7913c052e22f8bf3();
    }
}


class $294a9ab98e704f61$export$235cb65c20ad2b7 {
    constructor(x, y, type, shift){
        this.x = x;
        this.y = y;
        this.type = type;
        this.removed = false;
        this.shift = shift;
        this.velocity = 0;
        this.alpha = 1;
        this.processed = false;
    }
}


class $7b066675d1aa79fa$export$d26eb5a71ddec03b {
    constructor(config){
        this.windowSize = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // Timing and frames per second
        this.lastframe = 0;
        this.fpstime = 0;
        this.framecount = 0;
        this.fps = 0;
        this.initialized = false;
        this.resizeTimeout = null;
        this.level = {
            columns: 6,
            rows: 20,
            x: 4,
            y: 4,
            width: 0,
            height: 0,
            tilewidth: 0,
            tileheight: 0,
            rowheight: 50,
            radius: 20,
            tiles: [] // The two-dimensional tile array
        };
        this.neighborsoffsets = [
            [
                [
                    1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    -1,
                    1
                ],
                [
                    -1,
                    0
                ],
                [
                    -1,
                    -1
                ],
                [
                    0,
                    -1
                ]
            ],
            [
                [
                    1,
                    0
                ],
                [
                    1,
                    1
                ],
                [
                    0,
                    1
                ],
                [
                    -1,
                    0
                ],
                [
                    0,
                    -1
                ],
                [
                    1,
                    -1
                ]
            ]
        ] // Odd row tiles
        ;
        this.bubblecolors = 3;
        this.gamestates = {
            init: 0,
            ready: 1,
            shootbubble: 2,
            removecluster: 3,
            gameover: 4
        };
        this.gamestate = 0;
        this.score = 0;
        this.turncounter = 0;
        this.rowoffset = 0;
        // Animation variables
        this.animationstate = 0;
        this.animationtime = 0;
        // Clusters
        this.showcluster = false;
        this.cluster = [];
        this.floatingclusters = [];
        // Images
        this.images = [];
        // Image loading global variables
        this.loadcount = 0;
        this.loadtotal = 0;
        this.preloaded = false;
        this.existingcolors = [];
        this.timedDropInterval = null;
        this.handleResize = ()=>{
            if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
            this.resizeTimeout = window.setTimeout(()=>{
                this.resizeCanvas();
                this.adjustGameElements();
            }, 250);
        };
        this.main = (tframe)=>{
            // Request animation frames
            window.requestAnimationFrame(this.main);
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.update(tframe);
            this.render();
        };
        this.onMouseMove = (e)=>{
            // Get the mouse position
            var pos = this.getMousePos(this.canvas, e);
            // Get the mouse angle
            var mouseangle = this.radToDeg(Math.atan2(this.player.y + this.level.tileheight / 2 - pos.y, pos.x - (this.player.x + this.level.tilewidth / 2)));
            // Convert range to 0, 360 degrees
            if (mouseangle < 0) mouseangle = 180 + (180 + mouseangle);
            // Restrict angle to 8, 172 degrees
            var lbound = 8;
            var ubound = 172;
            if (mouseangle > 90 && mouseangle < 270) // Left
            {
                if (mouseangle > ubound) mouseangle = ubound;
            } else // Right
            if (mouseangle < lbound || mouseangle >= 270) mouseangle = lbound;
            // Set the player angle
            this.player.angle = mouseangle;
        };
        this.onMouseDown = (e)=>{
            // Get the mouse position
            var pos = this.getMousePos(this.canvas, e);
            if (this.gamestate == this.gamestates.ready) this.shootBubble();
            else this.gamestate, this.gamestates.gameover;
        };
        this.platform = new (0, $22f5f922ddc3e706$export$2dffd0b5373a4389)();
        this.config = config;
        this.canvas = window.document.getElementById("game-screen");
        this.context = this.canvas.getContext("2d");
        this.resizeCanvas();
        window.addEventListener("resize", this.handleResize);
        this.init();
    }
    resizeCanvas() {
        this.windowSize.width = window.innerWidth;
        this.windowSize.height = window.innerHeight;
        this.canvas.width = this.windowSize.width;
        this.canvas.height = this.windowSize.height;
    }
    adjustGameElements() {
    // Adjust game elements based on new canvas size
    // This method should be implemented to resize and reposition game elements
    // For example:
    // this.level.width = this.windowSize.width;
    // this.level.height = this.windowSize.height;
    // Recalculate positions of bubbles, player, etc.
    }
    init() {
        window.document.body.style.fontSize = this.config.fontSize + "px";
        window.document.body.style.color = this.config.fontColor;
        window.document.body.style.fontFamily = this.config.font;
        console.log("Init game...");
        this.bubblecolors = this.config.numberOfBallsOnSprite;
        this.level.columns = this.config.ballsPerRow;
        this.platform.init(this, this.config);
        this.platform.preloadSounds(this.config);
        this.player = new (0, $ac5fb69ba5837957$export$2616165974278734)();
        this.player.bubble.speed = this.config.speedOfShot;
        // Load images
        this.images = this.loadImages([
            this.config.ballSprite
        ]);
        this.bubbleimage = this.images[0];
        // Add mouse events
        this.canvas.addEventListener("mousemove", this.onMouseMove);
        this.canvas.addEventListener("mousedown", this.onMouseDown);
        var widthPerTiles = (this.windowSize.width - this.level.x * 2) / this.level.columns;
        this.level.tilewidth = (this.windowSize.width - this.level.x * 2 - widthPerTiles / 2) / this.level.columns;
        this.level.tileheight = this.level.tilewidth;
        this.level.rowheight = this.level.tilewidth;
        this.level.radius = this.level.rowheight / 2;
        this.level.width = this.windowSize.width;
        this.level.height = this.windowSize.height - this.level.tileheight - 22;
        this.level.rows = Math.round(this.level.height / this.level.tileheight);
        // Initialize the two-dimensional tile array
        for(var i = 0; i < this.level.columns; i++){
            this.level.tiles[i] = [];
            for(var j = 0; j < this.level.rows; j++)// Define a tile type and a shift parameter for animation
            this.level.tiles[i][j] = new (0, $294a9ab98e704f61$export$235cb65c20ad2b7)(i, j, 0, 0);
        }
        // Init the player
        this.player.x = this.level.x + this.level.width / 2 - this.level.tilewidth / 2;
        this.player.y = this.level.y + this.level.height;
        this.player.angle = 90;
        this.player.tiletype = 0;
        this.player.nextbubble.x = this.player.x - 2 * this.level.tilewidth;
        this.player.nextbubble.y = this.player.y;
        // this.newGame();
        // Enter main loop
        this.main(0);
    }
    checkForTimedDrop() {
        if (!this.config.secondsBeforeDrop) return;
        // Clear existing interval if there is one
        if (this.timedDropInterval !== null) return;
        this.timedDropInterval = setInterval(()=>{
            console.log("Timed drop...");
            if (this.gamestate === this.gamestates.ready) {
                this.addBubbles();
                this.rowoffset = (this.rowoffset + 1) % 2;
                if (this.checkGameOver()) {
                    clearInterval(this.timedDropInterval);
                    this.timedDropInterval = null;
                }
            }
        }, this.config.secondsBeforeDrop * 1000);
    }
    update(tframe) {
        var dt = (tframe - this.lastframe) / 1000;
        this.lastframe = tframe;
        // Update the fps counter
        this.updateFps(dt);
        if (this.gamestate == this.gamestates.ready) ;
        else if (this.gamestate == this.gamestates.shootbubble) // Bubble is moving
        this.stateShootBubble(dt);
        else if (this.gamestate == this.gamestates.removecluster) // Remove cluster and drop tiles
        this.stateRemoveCluster(dt);
    }
    setGameState(newgamestate) {
        console.log("New gamestate: " + newgamestate);
        this.gamestate = newgamestate;
        this.animationstate = 0;
        this.animationtime = 0;
        switch(this.gamestate){
            case this.gamestates.ready:
                console.log("Sending game ready event.");
                this.platform.gamestarted();
                return;
            case this.gamestates.gameover:
                console.log("Sending gameover event.");
                this.platform.gameover(this.score, null, null);
                document.getElementById("game-screen").style.opacity = "0";
                return;
        }
    }
    stateShootBubble(dt) {
        // Bubble is moving
        // Move the bubble in the direction of the mouse
        this.player.bubble.x += dt * this.player.bubble.speed * Math.cos(this.degToRad(this.player.bubble.angle));
        this.player.bubble.y += dt * this.player.bubble.speed * -1 * Math.sin(this.degToRad(this.player.bubble.angle));
        // Handle left and right collisions with the level
        if (this.player.bubble.x <= this.level.x) {
            // Left edge
            this.player.bubble.angle = 180 - this.player.bubble.angle;
            this.player.bubble.x = this.level.x;
        } else if (this.player.bubble.x + this.level.tilewidth >= this.level.x + this.level.width) {
            // Right edge
            this.player.bubble.angle = 180 - this.player.bubble.angle;
            this.player.bubble.x = this.level.x + this.level.width - this.level.tilewidth;
        }
        // Collisions with the top of the level
        if (this.player.bubble.y <= this.level.y) {
            // Top collision
            this.player.bubble.y = this.level.y;
            this.snapBubble();
            return;
        }
        // Collisions with other tiles
        for(var i = 0; i < this.level.columns; i++)for(var j = 0; j < this.level.rows; j++){
            var tile = this.level.tiles[i][j];
            // Skip empty tiles
            if (tile.type < 0) continue;
            // Check for intersections
            var coord = this.getTileCoordinate(i, j);
            if (this.circleIntersection(this.player.bubble.x + this.level.tilewidth / 2, this.player.bubble.y + this.level.tileheight / 2, this.level.radius, coord.tilex + this.level.tilewidth / 2, coord.tiley + this.level.tileheight / 2, this.level.radius)) {
                // Intersection with a level bubble
                this.snapBubble();
                return;
            }
        }
    }
    stateRemoveCluster(dt) {
        let oldScore = this.score;
        if (this.animationstate == 0) {
            this.resetRemoved();
            // Mark the tiles as removed
            for(var i = 0; i < this.cluster.length; i++)// Set the removed flag
            this.cluster[i].removed = true;
            this.cluster.forEach((tile)=>{
                this.score += this.findScoreForTile(tile);
            });
            // Find floating clusters
            this.floatingclusters = this.findFloatingClusters();
            if (this.floatingclusters.length > 0) {
                // Setup drop animation
                for(var i = 0; i < this.floatingclusters.length; i++)for(var j = 0; j < this.floatingclusters[i].length; j++){
                    var tile = this.floatingclusters[i][j];
                    tile.shift = 0;
                    tile.shift = 1;
                    tile.velocity = this.player.bubble.dropspeed;
                    console.log(tile);
                    this.score += this.findScoreForTile(tile);
                }
            }
            this.animationstate = 1;
        }
        if (this.animationstate == 1) {
            // Pop bubbles
            var tilesleft = false;
            for(var i = 0; i < this.cluster.length; i++){
                var tile = this.cluster[i];
                if (tile.type >= 0) {
                    tilesleft = true;
                    // Alpha animation
                    tile.alpha -= dt * 15;
                    if (tile.alpha < 0) tile.alpha = 0;
                    if (tile.alpha == 0) {
                        tile.type = -1;
                        tile.alpha = 1;
                    }
                }
            }
            // Drop bubbles
            for(var i = 0; i < this.floatingclusters.length; i++)for(var j = 0; j < this.floatingclusters[i].length; j++){
                var tile = this.floatingclusters[i][j];
                if (tile.type >= 0) {
                    tilesleft = true;
                    // Accelerate dropped tiles
                    tile.velocity += dt * 700;
                    tile.shift += dt * tile.velocity;
                    // Alpha animation
                    tile.alpha -= dt * 8;
                    if (tile.alpha < 0) tile.alpha = 0;
                    // Check if the bubbles are past the bottom of the level
                    if (tile.alpha == 0 || tile.y * this.level.rowheight + tile.shift > (this.level.rows - 1) * this.level.rowheight + this.level.tileheight) {
                        tile.type = -1;
                        tile.shift = 0;
                        tile.alpha = 1;
                    }
                }
            }
            if (!tilesleft) {
                // Next bubble
                this.nextBubble();
                // Check for game over
                var tilefound = false;
                for(var i = 0; i < this.level.columns; i++){
                    for(var j = 0; j < this.level.rows; j++)if (this.level.tiles[i][j].type != -1) {
                        tilefound = true;
                        break;
                    }
                }
                if (tilefound) this.setGameState(this.gamestates.ready);
                else // No tiles left, game over
                this.setGameState(this.gamestates.gameover);
            }
        }
        if (this.score != oldScore) this.platform.sendScore(this.score);
    }
    snapBubble() {
        // Get the grid position
        var centerx = this.player.bubble.x + this.level.tilewidth / 2;
        var centery = this.player.bubble.y + this.level.tileheight / 2;
        var gridpos = this.getGridPosition(centerx, centery);
        // Make sure the grid position is valid
        if (gridpos.x < 0) gridpos.x = 0;
        if (gridpos.x >= this.level.columns) gridpos.x = this.level.columns - 1;
        if (gridpos.y < 0) gridpos.y = 0;
        if (gridpos.y >= this.level.rows) gridpos.y = this.level.rows - 1;
        // Check if the tile is empty
        var addtile = false;
        if (this.level.tiles[gridpos.x][gridpos.y].type != -1) {
            // Tile is not empty, shift the new tile downwards
            for(var newrow = gridpos.y + 1; newrow < this.level.rows; newrow++)if (this.level.tiles[gridpos.x][newrow].type == -1) {
                gridpos.y = newrow;
                addtile = true;
                break;
            }
        } else addtile = true;
        // Add the tile to the grid
        if (addtile) {
            // Hide the player bubble
            this.player.bubble.visible = false;
            // Set the tile
            this.level.tiles[gridpos.x][gridpos.y].type = this.player.bubble.tiletype;
            // Check for game over
            if (this.checkGameOver()) return;
            // Find clusters
            this.cluster = this.findCluster(gridpos.x, gridpos.y, true, true, false);
            if (this.cluster.length >= 3) {
                // Remove the cluster
                this.setGameState(this.gamestates.removecluster);
                return;
            }
        }
        // No clusters found
        this.turncounter++;
        if (this.config.turnsBeforeDrop && this.turncounter >= this.config.turnsBeforeDrop) {
            // Add a row of bubbles
            this.addBubbles();
            this.turncounter = 0;
            this.rowoffset = (this.rowoffset + 1) % 2;
            if (this.checkGameOver()) return;
        }
        // Next bubble
        this.nextBubble();
        this.setGameState(this.gamestates.ready);
    }
    checkGameOver() {
        // Check for game over
        for(var i = 0; i < this.level.columns; i++)// Check if there are bubbles in the bottom row
        if (this.level.tiles[i][this.level.rows - 1].type != -1) {
            // Game over
            this.nextBubble();
            this.setGameState(this.gamestates.gameover);
            return true;
        }
        return false;
    }
    addBubbles() {
        // Move the rows downwards
        for(var i = 0; i < this.level.columns; i++)for(var j = 0; j < this.level.rows - 1; j++)this.level.tiles[i][this.level.rows - 1 - j].type = this.level.tiles[i][this.level.rows - 1 - j - 1].type;
        // Add a new row of bubbles at the top
        for(var i = 0; i < this.level.columns; i++)// Add random, existing, colors
        this.level.tiles[i][0].type = this.getExistingColor();
    }
    findColors() {
        var foundcolors = [];
        var colortable = [];
        for(var i = 0; i < this.bubblecolors; i++)colortable.push(false);
        // Check all tiles
        for(var i = 0; i < this.level.columns; i++)for(var j = 0; j < this.level.rows; j++){
            var tile = this.level.tiles[i][j];
            if (tile.type >= 0) {
                if (!colortable[tile.type]) {
                    colortable[tile.type] = true;
                    foundcolors.push(tile.type);
                }
            }
        }
        return foundcolors;
    }
    findCluster(tx, ty, matchtype, reset, skipremoved) {
        // Reset the processed flags
        if (reset) this.resetProcessed();
        // Get the target tile. Tile coord must be valid.
        var targettile = this.level.tiles[tx][ty];
        // Initialize the toprocess array with the specified tile
        var toprocess = [
            targettile
        ];
        targettile.processed = true;
        var foundcluster = [];
        while(toprocess.length > 0){
            // Pop the last element from the array
            var currenttile = toprocess.pop();
            // Skip processed and empty tiles
            if (currenttile.type == -1) continue;
            // Skip tiles with the removed flag
            if (skipremoved && currenttile.removed) continue;
            // Check if current tile has the right type, if matchtype is true
            if (!matchtype || currenttile.type == targettile.type) {
                // Add current tile to the cluster
                foundcluster.push(currenttile);
                // Get the neighbors of the current tile
                var neighbors = this.getNeighbors(currenttile);
                // Check the type of each neighbor
                for(var i = 0; i < neighbors.length; i++)if (!neighbors[i].processed) {
                    // Add the neighbor to the toprocess array
                    toprocess.push(neighbors[i]);
                    neighbors[i].processed = true;
                }
            }
        }
        // Return the found cluster
        return foundcluster;
    }
    findFloatingClusters() {
        // Reset the processed flags
        this.resetProcessed();
        var foundclusters = [];
        // Check all tiles
        for(var i = 0; i < this.level.columns; i++)for(var j = 0; j < this.level.rows; j++){
            var tile = this.level.tiles[i][j];
            if (!tile.processed) {
                // Find all attached tiles
                var foundcluster = this.findCluster(i, j, false, false, true);
                // There must be a tile in the cluster
                if (foundcluster.length <= 0) continue;
                // Check if the cluster is floating
                var floating = true;
                for(var k = 0; k < foundcluster.length; k++)if (foundcluster[k].y == 0) {
                    // Tile is attached to the roof
                    floating = false;
                    break;
                }
                if (floating) // Found a floating cluster
                foundclusters.push(foundcluster);
            }
        }
        return foundclusters;
    }
    resetProcessed() {
        for(var i = 0; i < this.level.columns; i++)for(var j = 0; j < this.level.rows; j++)this.level.tiles[i][j].processed = false;
    }
    resetRemoved() {
        for(var i = 0; i < this.level.columns; i++)for(var j = 0; j < this.level.rows; j++)this.level.tiles[i][j].removed = false;
    }
    getNeighbors(tile) {
        var tilerow = (tile.y + this.rowoffset) % 2; // Even or odd row
        var neighbors = [];
        // Get the neighbor offsets for the specified tile
        var n = this.neighborsoffsets[tilerow];
        // Get the neighbors
        for(var i = 0; i < n.length; i++){
            // Neighbor coordinate
            var nx = tile.x + n[i][0];
            var ny = tile.y + n[i][1];
            // Make sure the tile is valid
            if (nx >= 0 && nx < this.level.columns && ny >= 0 && ny < this.level.rows) neighbors.push(this.level.tiles[nx][ny]);
        }
        return neighbors;
    }
    updateFps(dt) {
        if (this.fpstime > 0.25) {
            // Calculate fps
            this.fps = Math.round(this.framecount / this.fpstime);
            // Reset time and framecount
            this.fpstime = 0;
            this.framecount = 0;
        }
        // Increase time and framecount
        this.fpstime += dt;
        this.framecount++;
    }
    drawCenterText(text, x, y, width) {
        var textdim = this.context.measureText(text);
        this.context.fillText(text, x + (width - textdim.width) / 2, y);
    }
    render() {
        var yoffset = this.level.tileheight / 2;
        // Render tiles
        this.renderTiles();
        // Draw level bottom
        this.context.fillStyle = this.config.bottomBarBackgroundColor;
        this.context.fillRect(this.level.x - 4, this.level.y - 4 + this.level.height + 4 - yoffset, this.level.width + 8, this.windowSize.height - (this.level.y - 4 + this.level.height + 4 - yoffset));
        // Draw score
        // this.context.fillStyle = "#ffffff";
        // this.context.font = "18px Verdana";
        // var scorex = this.level.x + this.level.width - 150;
        // var scorey = this.level.y+this.level.height + this.level.tileheight - yoffset - 8;
        // this.drawCenterText("Score:", scorex, scorey, 150);
        // this.context.font = "24px Verdana";
        // this.drawCenterText(this.score, scorex, scorey+30, 150);
        // Render cluster
        if (this.showcluster) {
            this.renderCluster(this.cluster, 255, 128, 128);
            for(var i = 0; i < this.floatingclusters.length; i++){
                var col = Math.floor(100 + 100 * i / this.floatingclusters.length);
                this.renderCluster(this.floatingclusters[i], col, col, col);
            }
        }
        // Render player bubble
        this.renderPlayer();
    // // Game Over overlay
    // if (this.gamestate == this.gamestates.gameover) {
    //     this.context.fillStyle = "rgba(0, 0, 0, 0.8)";
    //     this.context.fillRect(this.level.x - 4, this.level.y - 4, this.level.width + 8, this.level.height + 2 * this.level.tileheight + 8 - yoffset);
    //
    //     this.context.fillStyle = "#ffffff";
    //     this.context.font = "24px Verdana";
    //     this.drawCenterText("Game Over!", this.level.x, this.level.y + this.level.height / 2 + 10, this.level.width);
    //     this.drawCenterText("Click to start", this.level.x, this.level.y + this.level.height / 2 + 40, this.level.width);
    // }
    }
    renderTiles() {
        // Top to bottom
        for(var j = 0; j < this.level.rows; j++)for(var i = 0; i < this.level.columns; i++){
            // Get the tile
            var tile = this.level.tiles[i][j];
            // Get the shift of the tile for animation
            var shift = tile.shift;
            // Calculate the tile coordinates
            var coord = this.getTileCoordinate(i, j);
            // Check if there is a tile present
            if (tile.type >= 0) {
                // Support transparency
                this.context.save();
                this.context.globalAlpha = tile.alpha;
                // Draw the tile using the color
                this.drawBubble(coord.tilex, coord.tiley + shift, tile.type);
                this.context.restore();
            }
        }
    }
    renderCluster(cluster, r, g, b) {
        for(var i = 0; i < cluster.length; i++){
            // Calculate the tile coordinates
            var coord = this.getTileCoordinate(cluster[i].x, cluster[i].y);
            // Draw the tile using the color
            this.context.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
            this.context.fillRect(coord.tilex + this.level.tilewidth / 4, coord.tiley + this.level.tileheight / 4, this.level.tilewidth / 2, this.level.tileheight / 2);
        }
    }
    renderPlayer() {
        var centerx = this.player.x + this.level.tilewidth / 2;
        var centery = this.player.y + this.level.tileheight / 2;
        // Draw player background circle
        this.context.beginPath();
        this.context.arc(centerx, centery, this.level.radius + 12, 0, 2 * Math.PI, false);
        this.context.fill();
        this.context.lineWidth = 2;
        this.context.stroke();
        // Draw the angle
        this.context.lineWidth = 2;
        this.context.strokeStyle = "#0000ff";
        this.context.beginPath();
        this.context.moveTo(centerx, centery);
        this.context.lineTo(centerx + 1.5 * this.level.tilewidth * Math.cos(this.degToRad(this.player.angle)), centery - 1.5 * this.level.tileheight * Math.sin(this.degToRad(this.player.angle)));
        this.context.stroke();
        // Draw the next bubble
        this.drawBubble(this.player.nextbubble.x, this.player.nextbubble.y, this.player.nextbubble.tiletype);
        // Draw the bubble
        if (this.player.bubble.visible) this.drawBubble(this.player.bubble.x, this.player.bubble.y, this.player.bubble.tiletype);
    }
    getTileCoordinate(column, row) {
        var tilex = this.level.x + column * this.level.tilewidth;
        // X offset for odd or even rows
        if ((row + this.rowoffset) % 2) tilex += this.level.tilewidth / 2;
        var tiley = this.level.y + row * this.level.rowheight;
        return {
            tilex: tilex,
            tiley: tiley
        };
    }
    getGridPosition(x, y) {
        var gridy = Math.floor((y - this.level.y) / this.level.rowheight);
        // Check for offset
        var xoffset = 0;
        if ((gridy + this.rowoffset) % 2) xoffset = this.level.tilewidth / 2;
        var gridx = Math.floor((x - xoffset - this.level.x) / this.level.tilewidth);
        return {
            x: gridx,
            y: gridy
        };
    }
    drawBubble(x, y, index) {
        if (index < 0 || index >= this.bubblecolors) return;
        // Draw the bubble sprite
        this.context.drawImage(this.bubbleimage, index * this.bubbleimage.height, 0, this.bubbleimage.height, this.bubbleimage.height, x, y, this.level.tilewidth, this.level.tileheight);
    }
    createLevel() {
        // Create a level with random tiles
        for(var j = 0; j < this.level.rows; j++){
            var randomtile = this.getExistingColor();
            var count = 0;
            for(var i = 0; i < this.level.columns; i++){
                if (count >= 2) {
                    // Change the random tile
                    var newtile = this.getExistingColor();
                    // Make sure the new tile is different from the previous tile
                    if (newtile == randomtile) newtile = (newtile + 1) % this.bubblecolors;
                    randomtile = newtile;
                    count = 0;
                }
                count++;
                if (j < this.level.rows / 2) this.level.tiles[i][j].type = randomtile;
                else this.level.tiles[i][j].type = -1;
            }
        }
    }
    nextBubble() {
        // Set the current bubble
        this.player.tiletype = this.player.nextbubble.tiletype;
        this.player.bubble.tiletype = this.player.nextbubble.tiletype;
        this.player.bubble.x = this.player.x;
        this.player.bubble.y = this.player.y;
        this.player.bubble.visible = true;
        // Get a random type from the existing colors
        var nextcolor = this.getExistingColor();
        // Set the next bubble
        this.player.nextbubble.tiletype = nextcolor;
    }
    getExistingColor() {
        this.existingcolors = this.findColors();
        var bubbletype = 0;
        if (this.existingcolors.length > 0) bubbletype = this.generateBubbleType();
        return bubbletype;
    }
    generateBubbleType() {
        let ballSettings = this.config.ballSettings || [];
        if (!ballSettings) return this.existingcolors[this.randRange(0, this.existingcolors.length - 1)];
        for(let i = ballSettings.length; i < this.config.numberOfBallsOnSprite; i++)ballSettings.push({
            chance: 1,
            points: 100
        });
        const totalWeight = ballSettings.reduce((acc, setting)=>acc + setting.chance, 0);
        let random = Math.random() * totalWeight;
        for(let i = 0; i < ballSettings.length; i++){
            if (random < ballSettings[i].chance) return i; // return the index of the selected bubble type
            random -= ballSettings[i].chance;
        }
        return 0; // Default return, should not reach here if weights are set up correctly
    }
    randRange(low, high) {
        return Math.floor(low + Math.random() * (high - low + 1));
    }
    shootBubble() {
        // Shoot the bubble in the direction of the mouse
        this.player.bubble.x = this.player.x;
        this.player.bubble.y = this.player.y;
        this.player.bubble.angle = this.player.angle;
        this.player.bubble.tiletype = this.player.tiletype;
        // Set the gamestate
        this.setGameState(this.gamestates.shootbubble);
    }
    circleIntersection(x1, y1, r1, x2, y2, r2) {
        // Calculate the distance between the centers
        var dx = x1 - x2;
        var dy = y1 - y2;
        var len = Math.sqrt(dx * dx + dy * dy);
        if (len < r1 + r2) // Circles intersect
        return true;
        return false;
    }
    radToDeg(angle) {
        return angle * (180 / Math.PI);
    }
    // Convert degrees to radians
    degToRad(angle) {
        return angle * (Math.PI / 180);
    }
    getMousePos(canvas, e) {
        var rect = canvas.getBoundingClientRect();
        return {
            x: Math.round((e.clientX - rect.left) / (rect.right - rect.left) * canvas.width),
            y: Math.round((e.clientY - rect.top) / (rect.bottom - rect.top) * canvas.height)
        };
    }
    newGame() {
        console.log("Restarting game...");
        // Reset score
        this.score = 0;
        this.turncounter = 0;
        this.rowoffset = 0;
        // Create the level
        this.createLevel();
        // Set the gamestate to ready
        this.setGameState(this.gamestates.ready);
        // Init the next bubble and set the current bubble
        this.nextBubble();
        this.nextBubble();
        this.checkForTimedDrop();
        document.getElementById("game-screen").style.opacity = "1";
    }
    loadImages(imagefiles) {
        // Initialize variables
        this.loadcount = 0;
        this.loadtotal = imagefiles.length;
        this.preloaded = false;
        // Load the images
        var loadedimages = [];
        for(var i = 0; i < imagefiles.length; i++){
            // Create the image object
            var image = new Image();
            // Add onload event handler
            image.onload = ()=>{
                this.loadcount++;
                if (this.loadcount == this.loadtotal) // Done loading
                this.preloaded = true;
            };
            // Set the source url of the image
            image.src = imagefiles[i];
            // Save to the image array
            loadedimages[i] = image;
        }
        console.log("Loaded images:", loadedimages);
        // Return an array of images
        return loadedimages;
    }
    findScoreForTile(tile) {
        let ballSettings = this.config.ballSettings || [];
        for(let i = ballSettings.length; i < this.config.numberOfBallsOnSprite; i++)ballSettings.push({
            chance: 1,
            points: 100
        });
        return ballSettings[tile.type].points;
    }
    play() {
        this.newGame();
    }
    restart() {
        this.newGame();
    }
}


class $e45ba02351190ebe$export$f807d9a22ff8372d {
    async init(config) {
        this.preloadImages([
            config.ballSprite
        ]).then(()=>{
            new (0, $7b066675d1aa79fa$export$d26eb5a71ddec03b)(config);
        });
    }
    async preloadImages(sources) {
        return new Promise((resolve)=>{
            let loadedCounter = 0;
            sources.forEach((src)=>{
                if (!src) {
                    resolve();
                    return;
                }
                const image = new Image();
                image.onload = ()=>{
                    loadedCounter += 1;
                    if (loadedCounter === sources.length) resolve();
                };
                image.onerror = ()=>{
                    console.error(src + " was not found");
                    loadedCounter += 1;
                    if (loadedCounter === sources.length) resolve();
                };
                image.src = src;
            });
        });
    }
}


class $3e882aae5e9cba97$export$176c9ac0984acede {
    constructor(){
        this.turnsBeforeDrop = 0 // The amount of turns a player can de before the balls drop 1 row.
        ;
        this.secondsBeforeDrop = 0 // How many seconds before the balls drop
        ;
        this.speedOfShot = 1000 // The speed you shoot your own ball
        ;
        this.ballsPerRow = 8;
        this.ballSprite = "/images/bubble-sprites.png" // The path to the sprite of the balls
        ;
        this.numberOfBallsOnSprite = 6 // The amount of balls on the sprite.
        ;
        this.ballSettings = [
            {
                chance: 1,
                points: 100
            },
            {
                chance: 1,
                points: 500
            }
        ];
        this.bottomBarBackgroundColor = "#000000";
        this.fontSize = "12px";
        this.fontColor = "black";
        this.font = "Arial";
    }
} // turnsBeforeDrop=0
 // secondsBeforeDrop=30
 // speedOfShot=1000
 // ballsPerRow=8
 // ballSprite=/images/bubble-sprites.png
 // ballSettings=1:100,1:500
 // numberOfBallsOnSprite=6
 // bottomBarBackgroundColor=#000000;
 // fontSize=12px
 // fontColor=black
 // font=Arial


const $ad2bcec7a0192558$var$customConfig = $ad2bcec7a0192558$var$getSettingsFromURI(location.search);
let $ad2bcec7a0192558$var$config = new (0, $3e882aae5e9cba97$export$176c9ac0984acede)();
if ($ad2bcec7a0192558$var$customConfig) for (const [key, value] of Object.entries($ad2bcec7a0192558$var$customConfig)){
    if (key === "ballSettings") {
        const ballSettings = [];
        value.split(",").forEach((value)=>{
            const chance = value.split(":")[0] ?? 1;
            const score = value.split(":")[1] ?? 100;
            ballSettings.push({
                chance: parseInt(chance),
                points: parseInt(score)
            });
        });
        $ad2bcec7a0192558$var$config["ballSettings"] = ballSettings;
    } else if ([
        "turnsBeforeDrop",
        "secondsBeforeDrop",
        "speedOfShot",
        "numberOfBallsOnSprite",
        "ballsPerRow"
    ].includes(key)) $ad2bcec7a0192558$var$config[key] = parseInt(value);
    else $ad2bcec7a0192558$var$config[key] = value;
}
console.log($ad2bcec7a0192558$var$config);
const $ad2bcec7a0192558$var$configurator = new (0, $e45ba02351190ebe$export$f807d9a22ff8372d)();
$ad2bcec7a0192558$var$configurator.init($ad2bcec7a0192558$var$config);
function $ad2bcec7a0192558$var$getSettingsFromURI(uri) {
    let settingString;
    const split = uri.split("&");
    for (let s of split)if (s[0] === "s") settingString = decodeURIComponent(escape(atob(s.split("=")[1])));
    if (settingString === undefined) return null;
    let jsonString = "{";
    let settings = settingString.split("\n");
    settings.forEach((s)=>{
        const keyAndValue = s.split("=");
        if (keyAndValue.length === 1) return;
        const key = keyAndValue[0].trim();
        const value = keyAndValue[1].trim();
        if (value === "default") return;
        let line = '"' + key.toString() + '": ';
        if (value.includes("[") && value.includes("]")) line += value.toString();
        else line += '"' + value.toString() + '"';
        if (settings.indexOf(s) < settings.length - 1) line += ",";
        jsonString += line;
    });
    jsonString += "}";
    return JSON.parse(jsonString);
}


//# sourceMappingURL=index.ab10e13d.js.map
